import { render, staticRenderFns } from "./BackToList.vue?vue&type=template&id=341303c4&scoped=true&"
import script from "./BackToList.vue?vue&type=script&lang=ts&"
export * from "./BackToList.vue?vue&type=script&lang=ts&"
import style0 from "./BackToList.vue?vue&type=style&index=0&id=341303c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341303c4",
  null
  
)

export default component.exports